import Grid from "../Grid/grid";
import Title from "../title";
import Process from "../process";
import technologiesProcess from "./data/technologies-process";
import contentImage from "../../Assets/image/services-pages-images/web-development/web-development-content.webp";

function TechnologiesProcess() {
    return (
        <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
            <Grid size={100} direction="top-left" />
            <div className="z-10 flex justify-start items-start mb-12 w-full">
                <Title title="how we pick our stack" />
            </div>
            <Process
                data={technologiesProcess}
                img={contentImage}
                title="A Deliberate Approach"
                description="We don't chase trends — we choose technologies that solve your specific problem, backed by years of hands-on production experience."
            />
        </section>
    );
}

export default TechnologiesProcess;
